import axios from 'axios';

import { BaseUrl } from './httpClient';
import { getToken } from './tokenStorage';

const CancelToken = axios.CancelToken;
export const source = CancelToken.source();

const defaultOptions = {
  baseURL: BaseUrl,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

let instance = axios.create(defaultOptions);

instance.interceptors.request.use((config) => {
  const token = getToken();
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

export default instance;
